const transformOrganizationsFromApi = (apiData) => Object.entries(apiData).reduce((prev, [name, value]) => [...prev, {id: name, value }], []);

export default transformOrganizationsFromApi;
